import { openPopupAction } from 'editor/src/store/app/slice';
import type { Thunk } from 'editor/src/store/hooks';

import { BatchSelectionTotals } from 'editor/src/component/Popup/BatchSelectionPopup';
import { PopupName } from 'editor/src/component/Popup/popups';

import getPopupData from '../selector/getPopupData';

// Merges host-recomputed totals into the open batch selection popup, keeping
// the rows reference intact so the popup's local quantities are not re-seeded.
const setBatchSelectionTotalsOperation =
  (totals: BatchSelectionTotals): Thunk =>
  (dispatch, getState) => {
    const data = getPopupData(getState(), PopupName.BATCH_SELECTION_POPUP);
    if (!data) {
      return;
    }
    dispatch(openPopupAction({ open: PopupName.BATCH_SELECTION_POPUP, data: { ...data, totals } }));
  };

export default setBatchSelectionTotalsOperation;
